// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__33MjP","col":"styles_col__270JE","fulfillmentStatus":"styles_fulfillmentStatus__3Z3kA","emailCol":"styles_emailCol__1EFdy"};